"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var R = _interopRequireWildcard(require("ramda"));

var _react = require("react");

var _reactRedux = require("react-redux");

var _trackEvent = require("../store/trackEvent.actions");

var useTrackEvent = function useTrackEvent() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var setIdentity = (0, _react.useCallback)(function (id, traits, options) {
    return dispatch((0, _trackEvent.setIdentity)({
      id: id,
      traits: traits,
      options: options
    }));
  }, [dispatch]);
  var addUserProperties = (0, _react.useCallback)(function (properties) {
    return dispatch((0, _trackEvent.addUserProperties)(properties));
  }, [dispatch]);
  var trackEvent = (0, _react.useCallback)(function (name, payload, options) {
    if (payload && !R.is(Object, payload)) {
      throw Error('track event payload must be an object');
    }

    if (options && !R.is(Object, options)) {
      throw Error('track event options must be an object');
    }

    dispatch((0, _trackEvent.trackEvent)({
      name: name,
      payload: payload,
      options: options
    }));
  }, [dispatch]);
  return {
    setIdentity: setIdentity,
    addUserProperties: addUserProperties,
    trackEvent: trackEvent
  };
};

var _default = useTrackEvent;
exports["default"] = _default;